import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
  }

  jumpToAnchor(event) {
    // console.log('jump to anchor called')

    const field_name = event.target.dataset.fieldName;
    let field_anchor = Array.from(document.querySelectorAll(`[data-pc-name="tabs"] .field-anchor[data-field-name="${field_name}"]`))[0];

    if (field_anchor) {
      // If it's in a tab
      const tab_panel = field_anchor.closest('[data-pc-name="tabpanel"]')
      const tab_panel_id = tab_panel.id;
      const tab_link = tab_panel.closest('[data-pc-name="tabs"]').querySelector(`[aria-controls="${tab_panel_id}"]`)

      tab_link.click()

      setTimeout(function() {
        field_anchor.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 100)
    } else {
      // If it's not in a tab
      field_anchor = Array.from(document.querySelectorAll(`.single-tab .field-anchor[data-field-name="${field_name}"]`))[0];

      if (field_anchor) {
        setTimeout(function() {
          field_anchor.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }, 100)
      }
    }
  }

  jumpToField(event) {
    // console.log('jump to field called')

    const field_name = event.target.dataset.fieldName;
    let field = Array.from(document.querySelectorAll(`[data-pc-name="tabs"] [name="${field_name}"]:not([type="hidden"])`))[0];

    if (field) {
      // If it's in a tab
      const tab_panel = field_anchor.closest('[data-pc-name="tabpanel"]')
      const tab_panel_id = tab_panel.id;
      const tab_link = tab_panel.closest('[data-pc-name="tabs"]').querySelector(`[aria-controls="${tab_panel_id}"]`)

      tab_link.click()

      setTimeout(function() {
        field.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 100)
    } else {
      // If it's not in a tab
      field = Array.from(document.querySelectorAll(`.single-tab [name="${field_name}"]:not([type="hidden"])`))[0];

      if (field) {
        const form_row = field.closest('.form-row')
        form_row.classList.add('error')
        form_row.querySelector('.message').innerHTML = event.target.dataset.error;

        setTimeout(function() {
          field.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }, 100)
      }
    }
  }
}
